const COUNTRY_DAILY_PACE_TAGS = {
  PT: "SLOWER_PACE",
  GR: "SLOWER_PACE",
  CR: "SLOWER_PACE",
  MX: "SLOWER_PACE",
  PA: "SLOWER_PACE",
  HR: "SLOWER_PACE",
  UY: "SLOWER_PACE",
  EC: "SLOWER_PACE",
  TH: "SLOWER_PACE",
  ES: "BALANCED_PACE",
  FR: "BALANCED_PACE",
  IT: "BALANCED_PACE",
  CA: "BALANCED_PACE",
  NZ: "BALANCED_PACE",
  AU: "BALANCED_PACE",
  CL: "BALANCED_PACE",
  AR: "BALANCED_PACE",
  CO: "BALANCED_PACE",
  MY: "BALANCED_PACE",
  VN: "BALANCED_PACE",
  DE: "FASTER_PACE",
  NL: "FASTER_PACE",
  JP: "FASTER_PACE",
  SG: "FASTER_PACE",
};

const COUNTRY_DAILY_PACE_SENTENCES = {
  SLOWER_PACE: "Slower and more relaxed than the U.S.",
  BALANCED_PACE: "More balanced than the U.S.",
  FASTER_PACE: "More structured and time-sensitive than the U.S.",
};

const PACE_PRIORITY_KEY = "culture";
const PACE_DECISION_DESCRIPTORS = {
  SLOWER_PACE: "slower and more relaxed day to day",
  BALANCED_PACE: "more balanced day to day",
  FASTER_PACE: "more structured and time-sensitive day to day",
};

export const getPaceSignalState = (summary = {}) => {
  const priorities = Array.isArray(summary.priorities) ? summary.priorities : [];

  const paceSelected = priorities.includes(PACE_PRIORITY_KEY);
  const paceTopPriority = priorities.slice(0, 3).includes(PACE_PRIORITY_KEY);

  return {
    paceSelected,
    paceTopPriority,
    showCountryPaceDescriptions: paceTopPriority,
    showDecisionSentence: paceTopPriority,
    showLightPaceMention: paceSelected && !paceTopPriority,
  };
};

export const getPacePreference = (summary = {}) => {
  const { paceSelected, paceTopPriority } = getPaceSignalState(summary);

  if (paceTopPriority) return "PACE_PRIORITY_TOP_3";
  if (paceSelected) return "PACE_PRIORITY_SELECTED";
  return "NOT_SELECTED";
};

export const getCountryDailyPaceTag = (countryCode = "") => COUNTRY_DAILY_PACE_TAGS[countryCode] || "BALANCED_PACE";

export const getCountryDailyPaceDescription = (countryCode = "") => {
  const paceTag = getCountryDailyPaceTag(countryCode);
  return COUNTRY_DAILY_PACE_SENTENCES[paceTag] || COUNTRY_DAILY_PACE_SENTENCES.BALANCED_PACE;
};

export const summaryAlreadyMentionsPace = (text = "") => {
  return /(pace|rhythm|slower|relaxed|balanced|structured|time-sensitive)/i.test(text);
};

export const getPaceLightMention = (summary = {}) => {
  return getPaceSignalState(summary).showLightPaceMention
    ? "Daily pace still matters here, but it is not the main separator."
    : "";
};

export const shouldShowPaceSignal = (countries = [], summary = {}) => {
  return getPaceSignalState(summary).paceSelected && countries.length >= 1;
};

export const getPaceDecisionContrast = (countries = [], summary = {}) => {
  if (!getPaceSignalState(summary).showDecisionSentence || countries.length < 2) return "";

  const leadCountry = countries[0];
  const alternativeCountry = countries[1];
  const leadTag = getCountryDailyPaceTag(leadCountry.code);
  const alternativeTag = getCountryDailyPaceTag(alternativeCountry.code);

  if (leadTag === alternativeTag) {
    return `${leadCountry.name} and ${alternativeCountry.name} both feel ${PACE_DECISION_DESCRIPTORS[leadTag]}, so pace does not do much to separate them.`;
  }

  return `${leadCountry.name} feels ${PACE_DECISION_DESCRIPTORS[leadTag]}, while ${alternativeCountry.name} feels ${PACE_DECISION_DESCRIPTORS[alternativeTag]}.`;
};